import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';

export const DiscoverCardRoot = styled.article`
	position: relative;
	overflow: hidden;
	width: 100%;
	height: clamp(600px, 78vh, 720px);
	margin-bottom: 18px;
	scroll-snap-align: start;
	scroll-snap-stop: always;
	border: 0;
	border-radius: 24px;
	background: #070509;
	box-shadow: 0 18px 44px rgba(0, 0, 0, 0.42);
	isolation: isolate;
	cursor: pointer;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		height: 100dvh;
		min-height: 100dvh;
		margin-bottom: 0;
		border-radius: 0;
		box-shadow: none;
	}
`;

export const DiscoverMediaSkeleton = styled.div`
	position: absolute;
	inset: 0;
	z-index: -2;
`;

export const DiscoverImage = styled.img`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center center;
	opacity: ${(props) => (props.$visible ? 1 : 0)};
	visibility: ${(props) => (props.$visible ? 'visible' : 'hidden')};
	transition: opacity 200ms ease, visibility 200ms ease;
	z-index: -2;
`;

export const DiscoverVideo = styled.video`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center center;
	opacity: ${(props) => (props.$visible ? 1 : 0)};
	visibility: ${(props) => (props.$visible ? 'visible' : 'hidden')};
	transition: opacity 200ms ease, visibility 200ms ease;
	z-index: -1;
`;

export const DiscoverShade = styled.div`
	position: absolute;
	inset: 0;
	background: linear-gradient(
		180deg,
		rgba(0, 0, 0, 0.04) 0%,
		rgba(0, 0, 0, 0.02) 48%,
		rgba(0, 0, 0, 0.76) 100%
	);
	z-index: 0;
	pointer-events: none;
`;

export const DiscoverInfo = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 10px;
	padding: 0 30px 30px;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		padding: 0 22px 0;
		gap: 10px;
	}
`;

export const DiscoverTitle = styled.div`
	h2 {
		margin: 0 0 5px;
		color: #fff;
		font-family: ${THEME.fontApp};
		font-size: clamp(1.72rem, 2.4vw, 2.08rem);
		font-weight: 800;
		line-height: 0.96;
		text-shadow: 0 3px 18px rgba(0, 0, 0, 0.7);

		span {
			margin-left: 6px;
			color: rgba(255, 255, 255, 0.72);
			font-size: 1em;
			font-weight: 700;
		}
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		padding-bottom: 2px;
	}
`;

export const DiscoverBio = styled.p`
	display: -webkit-box;
	margin: 0 0 14px;
	max-width: 100%;
	color: rgba(255, 255, 255, 0.84);
	font-family: ${THEME.fontApp};
	font-size: 0.9rem;
	font-weight: 400;
	line-height: 1.28;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	text-shadow: 0 2px 12px rgba(0, 0, 0, 0.68);

	@media (max-width: ${THEME.mobileBreakpoint}) {
		margin-bottom: 10px;
	}
`;

export const DiscoverChatButton = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-height: 42px;
	padding: 0 18px;
	border: 1px solid rgba(255, 255, 255, 0.28);
	border-radius: 999px;
	color: #fff;
	font-family: ${THEME.fontApp};
	font-size: 0.88rem;
	font-weight: 900;
	background:
		linear-gradient(135deg, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0.055)),
		rgba(10, 4, 14, 0.34);
	box-shadow:
		0 14px 30px rgba(0, 0, 0, 0.26),
		inset 0 1px 0 rgba(255, 255, 255, 0.16);
	backdrop-filter: blur(16px) saturate(1.18);
	cursor: pointer;
	transition:
		transform 180ms ease,
		border-color 180ms ease,
		background 180ms ease,
		box-shadow 180ms ease;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		margin-bottom: calc(52px + env(safe-area-inset-bottom, 0px));
	}

	&:hover,
	&:focus-visible {
		transform: translateY(-2px);
		border-color: rgba(255, 126, 237, 0.52);
		background:
			linear-gradient(135deg, rgba(255, 77, 242, 0.24), rgba(255, 211, 107, 0.14)),
			rgba(10, 4, 14, 0.42);
		box-shadow:
			0 18px 38px rgba(0, 0, 0, 0.32),
			0 0 22px rgba(255, 77, 242, 0.14),
			inset 0 1px 0 rgba(255, 255, 255, 0.18);
	}
`;
